import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { connect } from 'react-redux';
import theme from '../../muiTheme';
const styles = {
  errorDialogContent: {
    width: "500px"
  },
  errorDialogTitle: {
    color: theme.palette.accent1Color
  }
};

class RelationshipDialog extends Component
{

    render() {

      if (!this.props.displayPackage) 
      {
        return '';
      }

      return (
        <Dialog
         title="Relationship Details"
         modal={true}
         titleStyle={styles.errorDialogTitle}
         open={this.props.open}
         fullScreen
         autoScrollBodyContent={true}>
        <Paper elevation={3}>
          <Table>
            <TableBody>
                <TableRow>
                    <TableCell style={{textAlign: 'left', fontSize: '0.8em', padding: '8px', fontWeight:'bold'}}>Relationship Type</TableCell>
                    <TableCell>{this.props.displayPackage.RelationshipType}</TableCell>
                </TableRow> 
                <TableRow>
                    <TableCell style={{textAlign: 'left', fontSize: '0.8em', padding: '8px', fontWeight:'bold'}}>Created By System</TableCell>
                    <TableCell>{this.props.displayPackage.CreatedBySystem}</TableCell>
                </TableRow> 
                <TableRow>
                    <TableCell style={{textAlign: 'left', fontSize: '0.8em', padding: '8px', fontWeight:'bold'}}>Is Active?</TableCell>
                    <TableCell>{this.props.displayPackage.IsActive}</TableCell>
                </TableRow> 
                <TableRow>
                    <TableCell style={{textAlign: 'left', fontSize: '0.8em', padding: '8px', fontWeight:'bold'}}>Created On</TableCell>
                    <TableCell>{this.props.displayPackage.CreatedOn}</TableCell>
                </TableRow> 
                <TableRow>
                    <TableCell style={{textAlign: 'left', fontSize: '0.8em', padding: '8px', fontWeight:'bold'}}>Last Modified On</TableCell>
                    <TableCell>{this.props.displayPackage.ModifiedOn}</TableCell>
                </TableRow> 
                
                <TableRow>
                    <TableCell style={{textAlign: 'left', fontSize: '0.8em', padding: '8px', fontWeight:'bold'}}>Expired On</TableCell>
                    <TableCell>{this.props.displayPackage.ExpiredOn}</TableCell>
                </TableRow> 
                <TableRow>
                    <TableCell style={{textAlign: 'left', fontSize: '0.8em', padding: '8px', fontWeight:'bold'}}>Relationship Type</TableCell>
                    <TableCell>{this.props.displayPackage.RelationshipType}</TableCell>
                </TableRow> 
                <TableRow>
                    <TableCell style={{textAlign: 'left', fontSize: '0.8em', padding: '8px', fontWeight:'bold'}}>Is Parent?</TableCell>
                    <TableCell>{this.props.displayPackage.IsParent}</TableCell>
                </TableRow> 
                <TableRow>
                    <TableCell style={{textAlign: 'left', fontSize: '0.8em', padding: '8px', fontWeight:'bold'}}>Is Child?</TableCell>
                    <TableCell>{this.props.displayPackage.IsChild}</TableCell>
                </TableRow> 

          </TableBody>
          </Table>
          <DialogActions>
           <Button onClick={this.props.onCloseRelationshipDialog} color="primary">
             Close
           </Button>
             
         </DialogActions>
        </Paper>
      </Dialog>
      )
    }
}

const mapStateToProps = state => ({
  appConfig: state.config
})

export default connect(mapStateToProps)(RelationshipDialog)
